<template>
  <div id="app" class="fm-pcn-app" v-setTab>
    <router-view />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#app {
  height: 100vh;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none; //Safari and Chrome
  }
}
</style>
